import * as React from "react";
import name from "../../../../assets/images/generic/nuvama_name_logo.png";
import { Link } from "react-router-dom";
const Logo = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "logo" },
            React.createElement(Link, { to: "/" },
                React.createElement("img", { src: name, alt: "nuvama", width: 150 })))));
};
export default Logo;
